module.exports = __webpack_public_path__ + "static/media/gridIcon.381ed3fc.svg";